import { defineComponent as _defineComponent } from 'vue'
import { ContactHealthScoreModel } from '@/types';
import { getContactHealthScoreTrend } from '@/utils/contactHealthScore';
import ActivityIcon from '@/assets/icons/activity.svg';
import { computed } from 'vue';

interface Props {
    healthScore: ContactHealthScoreModel;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactHealthScoreBadge',
  props: {
    healthScore: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const status = computed(() => {
    if (props.healthScore?.trend == null) return null;
    return getContactHealthScoreTrend(props.healthScore?.trend);
});
const scoreColor = (score: number) => {
    if (score >= 70) return 'bg-success-200 text-success-700';
    if (score >= 30) return 'bg-warning-200 text-warning-800';
    return 'bg-danger-200 text-danger';
};

const __returned__ = { props, status, scoreColor, get ActivityIcon() { return ActivityIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})